import { generateHttpActions } from 'utility';
import axios from 'axios';
import { isNil, map } from 'lodash';
import { AxiosHttpError } from 'utility/errors';
import transform from './utility/05_countryDrillDownCurve';
import checkResponse from './utility/04_enrolmentCurveAndForecast/responses.check';
import {
  mockDropoutResponse,
  mockCountryActivationResponse,
} from '../../../../utility/redux/emptyResponses';

function trialCountryDrillDownDataHttpRequest(
  trialId,
  countryCode,
  viewType,
  showEnrollmentMetrics,
  showActivationMetrics,
  hasEnrollmentView,
) {
  const httpActions = generateHttpActions('countryDrillDown');
  const resourceCountryeActivation = `trial-management/country-activation/trial/${trialId}?country_code=${countryCode}`;
  const resourceDropout = `trial-management/country-summary-graph-metrics/trial/${trialId}?country_code=${countryCode}`;

  return async (dispatch) => {
    dispatch(httpActions.start());
    let responses = [];
    const responseErrors = [];
    let responsesFailureCount = 0;
    try {
      const resources = [resourceCountryeActivation, resourceDropout];
      const emptyResponsePayloads = [
        mockCountryActivationResponse,
        mockDropoutResponse,
      ];
      const checkedResponses = resources.map((resource) =>
        checkResponse(axios.get(resource)),
      );
      responses = await Promise.all(checkedResponses);
      responses = responses.map((responseItem, index) => {
        const { response } = responseItem;
        if (isNil(response)) {
          responsesFailureCount += 1;
          responseErrors.push(responseItem.error);
          return emptyResponsePayloads[index];
        }
        return response;
      });

      const responsesData = map(responses, 'data');
      const transformData = transform(
        ...responsesData,
        viewType,
        showEnrollmentMetrics,
        showActivationMetrics,
        hasEnrollmentView,
      );
      if (responsesFailureCount > 3) {
        const errorDetails = responseErrors[0].details;
        throw new AxiosHttpError(errorDetails);
      }

      dispatch(httpActions.success({ data: transformData }));
    } catch (error) {
      dispatch(httpActions.error(error));
    }
  };
}

export default trialCountryDrillDownDataHttpRequest;
